import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSuppliers, deleteSupplier } from "./modules/actions";
import Dobavljaci from "./View";

const mapStateToProps = (state) => ({
  suppliers: state.suppliersReducer.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getSuppliers,
      deleteSupplier,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dobavljaci);
